import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getSlideAnnotationsByPresentationId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide-annotation?presentationId={presentationId}`,
  },
  updateAnnotationVisibility: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/{slideId}/slide:touch`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

/**
 * Fetch all annotations for slides in a presentation
 * @param {string|number} presentationId - ID of the presentation
 * @param {Object} options - Additional options
 * @param {string} [options.type] - Optional filter by annotation type (AI, THIRD_PARTY, CUSTOM, etc.)
 * @returns {Promise<Array>} - Array of annotation objects
 */
const getSlideAnnotationsByPresentationId = async (presentationId, options = {}) => {
  // Create params object with presentationId as path parameter
  const pathParams = { presentationId }

  // Additional query params for type if provided
  const queryParams = options.type ? { type: options.type } : {}

  const res = await resource.getSlideAnnotationsByPresentationId(pathParams, queryParams)
  return res.body
}

const updateAnnotationVisibility = async (slideId) => {
  const res = await resource.updateAnnotationVisibility({ slideId }, {})
  return res.body
}

export default {
  initResource,
  getSlideAnnotationsByPresentationId,
  updateAnnotationVisibility,
}
